/* eslint-disable jsx-a11y/alt-text */
import React, { Fragment } from "react";
import Constants from "app_constants";
import Theme from "./theme";

import visaMasterCard from "assets/img/visa_mastercard.jpg";
import paylane from "assets/img/paylane.png";

const PaymentView = (props) => {
  const { pay, setFormData, error, product } = props;

  return (
    <Theme>
      {Constants.metaTag}

      <form className="panel" id="checkout-form" action="" type="">
        <img
          width="100"
          style={{ marginBottom: 10 }}
          src={visaMasterCard}
          className="visaMasterCard is-hidden-tablet"
        />

        <div className="box">
          <img
            src={visaMasterCard}
            className="visaMasterCard is-hidden-mobile"
          />

          {product === "standard" && (
            <Fragment>
              <p className="is-hidden-mobile">
                ( You are buying <b>1 Job Ad</b> )
              </p>
              <p className="is-hidden-tablet product">
                <b>( 1 Job Ad )</b>
              </p>
            </Fragment>
          )}

          {product === "boost" && (
            <Fragment>
              <p className="is-hidden-mobile">
                ( You are buying <b>1 featured Job Ad</b> )
              </p>
              <p className="is-hidden-tablet product">
                <b>( 1 featured Job Ad )</b>
              </p>
            </Fragment>
          )}

          {product === "professional" && (
            <Fragment>
              <p className="is-hidden-mobile">
                ( You are buying <b>5 Job Ads</b> )
              </p>
              <p className="is-hidden-tablet product">
                <b>( 5 Job Ads )</b>
              </p>
            </Fragment>
          )}

          {product === "enterprise" && (
            <Fragment>
              <p className="is-hidden-mobile">
                ( You are buying <b>5 featured Job Ads</b> )
              </p>
              <p className="is-hidden-tablet product">
                <b>( 5 featured Job Ads )</b>
              </p>
            </Fragment>
          )}

          <div className="rightSection">
            <p>Price: </p>
            &nbsp; &nbsp;
            {product === "standard" && (
              <Fragment>
                <h3 className="title is-3 is-hidden-mobile">€50</h3>
                <h3 className="title is-5 is-hidden-tablet">€50</h3>
              </Fragment>
            )}
            {product === "professional" && (
              <Fragment>
                <h3 className="title is-3 is-hidden-mobile">€200</h3>
                <h3 className="title is-5 is-hidden-tablet">€200</h3>
              </Fragment>
            )}
            {product === "enterprise" && (
              <Fragment>
                <h3 className="title is-3 is-hidden-mobile">€300</h3>
                <h3 className="title is-5 is-hidden-tablet">€300</h3>
              </Fragment>
            )}
            {product === "boost" && (
              <Fragment>
                <h3 className="title is-3 is-hidden-mobile">€60</h3>
                <h3 className="title is-5 is-hidden-tablet">€60</h3>
              </Fragment>
            )}
          </div>
        </div>

        {error && <p className="error">An error occured. Please try again!</p>}

        <div className="field">
          <label className="label">Card Number</label>
          <div className="control">
            <input
              data-paylane="cc-number"
              onChange={(e) => {
                setFormData("cardNumber", e.target.value);
              }}
              className="input is-info"
              type="text"
            />
          </div>
        </div>

        <div className="field">
          <label className="label">Name & Surname</label>
          <div className="control">
            <input
              data-paylane="cc-name-on-card"
              onChange={(e) => {
                setFormData("name", e.target.value);
              }}
              className="input is-info"
              type="text"
            />
          </div>
        </div>

        <div className="field">
          <label className="label">E-mail</label>
          <div className="control">
            <input
              onChange={(e) => {
                setFormData("email", e.target.value);
              }}
              className="input is-info"
              type="email"
            />
          </div>
        </div>

        <div className="columns">
          <div className="column">
            <div className="field">
              <label className="label">Expiration Date</label>
              <div className="columns">
                <div className="column">
                  <div className="control">
                    <input
                      data-paylane="cc-expiry-month"
                      onChange={(e) => {
                        setFormData("expirationMonth", e.target.value);
                      }}
                      className="input is-info"
                      type="text"
                      placeholder="01"
                    />
                  </div>
                </div>
                <div className="column">
                  <div className="control">
                    <input
                      data-paylane="cc-expiry-year"
                      onChange={(e) => {
                        setFormData("expirationYear", e.target.value);
                      }}
                      className="input is-info"
                      type="text"
                      placeholder="2019"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="column">
            <div className="field">
              <label className="label">Security Code (CVV)</label>
              <div className="control">
                <input
                  data-paylane="cc-cvv"
                  onChange={(e) => {
                    setFormData("CVV", e.target.value);
                  }}
                  className="input is-info"
                  type="text"
                  placeholder="123"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="field">
          <label className="label">Adress</label>
          <div className="control">
            <input className="input is-info" type="text" />
          </div>
        </div>

        {/*

                <div className="field">
                    <div className="jobType" >
                        <label className="radio">
                            <input onChange={()=>{setFormData('type', 'full-time')}} type="radio" name="rsvp" />
                            &nbsp;
                            <span>Use 3D Secure</span>
                        </label>
                    </div>
                </div>

                */}

        <button
          onClick={(e) => pay(e)}
          className="button is-info is-fullwidth submit"
        >
          Submit
        </button>

        <br />

        <div className="paymentGateway">
          <p className="info">Payment gateway: </p>

          <img
            src={paylane}
            width="150"
            onClick={() => window.open("https://paylane.com", "_blank")}
          />
        </div>
      </form>
    </Theme>
  );
};

export default PaymentView;
